// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1ArWA","container":"styles_container__Sre0h","title":"styles_title__Rn9x-","wrapper":"styles_wrapper__2NgAR","answer":"styles_answer__3T30O"};